import { Tracking, TrackingDetails } from "../api";
import { getLogger } from "@parcel2go/logging/dist/logging";
const logger = getLogger();

/**
 * Gets all the tracking events from all parcels and finds the latest scan
 * @param {Tracking} t The tracking information
 * @returns {Date} Returns the date of the of the latest scan if possible else returns null.
 */
export function GetLastTrackingEventTimeStamp(t: Tracking): Date | null {
    try {
        if (t.parcels) {
            const trackingDetails = Object.values(t.parcels);
            const events = trackingDetails.map((td) => td.events.map((event) => new Date(event.timestamp))).reduce((a,b) => a.concat(b));
            return events.sort((a, b) => b.getTime() - a.getTime())[0];
        }
    }
    catch (e) {
        logger.error("Unable to parse tracking details within GetLastTrackingEventTimeStamp function. %o", e)
    }
    
    return null;
}

/**
 * Gets tracking events from a single parcel and finds the latest scan
 * @param {TrackingDetails} td The tracking information
 * @returns {Date} Returns the date of the of the latest scan if possible else returns null.
 */
export function GetLastTrackingEventTimeStampSingleParcel(td: TrackingDetails): Date | null {
    try {
        if (td) {
            const events = td.events.map((event) => new Date(event.timestamp));;
            return events.sort((a, b) => b.getTime() - a.getTime())[0];
        }
    }
    catch (e) {
        logger.error("Unable to parse tracking details within GetLastTrackingEventTimeStampSingleParcel function. %o", e)
    }
    
    return null;
}

/**
 * Returns a timestamp in the past based off the number of days entered
 * @param {number} numOfDays The number of days in the past you want the time stamp for
 * @returns {number} Returns the timestamp. 
 */
export function GetRelativeTimestampByDays(numOfDays: number): number {
    return new Date().getTime() - (numOfDays * 24 * 60 * 60 * 1000);
}

/**
 * Returns whether the estimated delivery date has passed for a given tracking object. 
 * Returns false if unable to determine. 
 * @param {Tracking} t The tracking event
 * @returns {boolean} Returns whether the delivery date has passed. 
 */
export function HasEstimatedDeliveryDatePassed(t: Tracking): boolean {
    try {
        const estimatedDeliveryDateString = t.order.estimatedDeliveryDate;
        
        if (estimatedDeliveryDateString) {
            const estimatedDeliveryDate = new Date(estimatedDeliveryDateString); 
            
            return estimatedDeliveryDate.getTime() < new Date().getTime(); 
        }
    }
    catch (e) {
        logger.error("Unable to determine if the estimated delivery date has passed. %o", e)
    }
    
    return false;
}

/**
 * Sets the canonical tag to be the url provided. 
 * Does nothing if head does not exist
 * @param {string} hostURL The url to set
 * @param {string} protocolURL The protocol of the link
 */
export function SetCanonicalTag (protocolURL: string, hostURL: string) {
    const headElement = document.head;
    if(headElement){
        const tag = document.createElement("link");
        tag.setAttribute("rel", "canonical");
        tag.setAttribute("href", protocolURL+"//"+hostURL+"/tracking/");
        headElement.appendChild(tag);
    }
}